import { onTurboPageLoad } from '../turboHelper';
import { getModel } from '../modelHelper';
import { attachSummernote } from '../summernoteHelper';
import { getScoreFunctionPreservingOrderInSearch, selectize } from '../selectizeHelper';


onTurboPageLoad("Pois/CreateOrEdit", () => {
    const model = getModel<IPoiCreateOrEditModel>();

    const editorInputs = $(".html-editor");
    attachSummernote(editorInputs);
     
    //TODO: check if all files uploaded before submitting form
    //?? introduce hidden "allFilesUploaded" field with validation on "true" value?
    //?? dropzone.getFilesWithStatus(status !== Dropzone.SUCCESS)

    onCategoryChangeOptionallyResetSubcategory();

    // todo: this code is copy&pasted to DetailCategoryController.ts; remove this later
    function onCategoryChangeOptionallyResetSubcategory() {
        const categorySelects = $(`#${model.categorySelectId} input`);
        const subcategorySelect = $(`#${model.subcategorySelectId}`);
        selectize(subcategorySelect, {
            score: getScoreFunctionPreservingOrderInSearch
        });
        const subcategorySelectize = subcategorySelect[0].selectize;

        categorySelects.change(() => {
            const selectedCategory = $(categorySelects).toArray()
                .map(el => el as HTMLInputElement)
                .find(el => el.checked)?.value;

            const isPracticalCategory = selectedCategory === model.practicalCategoryCharCodeAsString;
            if (isPracticalCategory) {
                subcategorySelectize.enable();
            } else {
                subcategorySelectize.setValue("", false);
                subcategorySelectize.disable();
            }
            $(`#${model.isUnimportantInputId}`).prop("checked", isPracticalCategory);
        });
    }
});

interface IPoiCreateOrEditModel {
    isCreate: boolean;

    categorySelectId: string;
    subcategorySelectId: string;
    isUnimportantInputId: string;

    practicalCategoryCharCodeAsString: string;
    shouldEnableDataValidationInputName: string;
}
